import { nowIsoAndUnix } from "@@/shared/date-time/iso-and-unix";
import type { Except } from "type-fest";
import type { Optional } from "./optional";
import type {
    OptionalAmountId} from "./optional-amount-id";
import {
    optionalAmountIdFactory,
} from "./optional-amount-id";
import type { OptionalGroup } from "./optional-group";

type OptionalAmount = Except<OptionalGroup, "_id" | "optionals" | "_type"> & {
    readonly _id: OptionalAmountId;
    readonly _type: "OPTIONAL_AMOUNT";
    readonly optional: Optional;
};

type FactoryParams = Except<OptionalAmount, "_id" | "_type" | "_createdAt">;
const optionalAmountFactory = (
    params: FactoryParams & { _id?: OptionalAmountId },
): OptionalAmount => {
    return {
        ...params,
        _id: params._id || optionalAmountIdFactory(),
        _type: "OPTIONAL_AMOUNT",
        _createdAt: nowIsoAndUnix(),
    };
};

export { optionalAmountFactory };
export type { OptionalAmount, OptionalAmountId };
